import * as files from '@/API/files'
// 上传文件
export function uploadCommon (f, name) {
  console.log('f', f)
  const param = new FormData()
  param.append('img', f.file)
  return new Promise((resolve, reject) => {
    files
      .createSetting(param)
      .then(response => {
        console.log('response', response)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export function uploadVideoCommon (f, name) {
  console.log('f', f)
  const param = new FormData()
  param.append('video', f.file)
  return new Promise((resolve, reject) => {
    files
      .createVideo(param)
      .then(response => {
        console.log('response', response)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
// 获取日期,默认当前时间
export function getDay (type, date = new Date()) {
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let days = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let milliseconds = date.getMilliseconds()
  month = month < 10 ? '0' + month : month
  days = days < 10 ? '0' + days : days
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  if (milliseconds < 100) {
    milliseconds = '0' + milliseconds
    if (milliseconds < 10) {
      milliseconds = '0' + milliseconds
    }
  }
  switch (type) {
    case 'dayTime':
      return (
        year.toString() +
        '-' +
        month.toString() +
        '-' +
        days.toString() +
        ' ' +
        hour.toString() +
        ':' +
        minute.toString() +
        ':' +
        second.toString()
      )
    case 'day':
      return year.toString() + '-' + month.toString() + '-' + days.toString()
    case 'month':
      return year.toString() + '-' + month.toString()
    case 'year':
      return year.toString()
    case 'dayString':
      return year.toString() + '年' + month.toString() + '月' + days.toString() + '日'
    case 'milliseconds':
      return (
        year.toString() +
        month.toString() +
        days.toString() +
        hour.toString() +
        minute.toString() +
        second.toString() +
        milliseconds.toString()
      )
    default:
      return year.toString() + '-' + month.toString() + '-' + days.toString()
  }
}
